export default __webpack_public_path__ + "static/media/time.92155153.svg";